<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">
      Link to Camera
    </v-card-title>

    <v-card-text>
      <v-container>

        <v-data-table
          :headers="tableHeaders"
          :items="priorityConfig"
        >
          <template v-slot:item.action[0].cameraChannel[0]="{item}">
            <v-select
              v-model="item.action[0].cameraChannel[0]"
              :items="parsedChannels"
              item-text="label"
              item-value="val"
              @change="validatePriority(item, item.action[0].cameraChannel[0], 'channel')"
            />
          </template>

          <template v-slot:item.action[0].priority[0]="{item}">
            <v-select
              v-model="item.action[0].priority[0]"
              :items="parsedPins"
              item-text="label"
              item-value="val"
              @change="validatePriority(item, item.action[0].priority[0])"
            />
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
    
    <v-card-actions>
      <v-btn
        color="primary"
        text
        @click="closeDialog"
      >
        CANCEL
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        @click="saveCameraLinkSettings"
      >
        SAVE
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { Logger } from "aws-amplify";
const logger = new Logger("Link to Camera");

export default {
  name: 'LinkToCamera',
  props: {
    action: {
      type: Object,
      required: true
    },
    pinList: {
      type: Array,
      required: true
    },
    channels: {
      type: Array,
      required: true
    },
    priorityConfig: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      tableHeaders: [
        {
          text: 'Pin',
          value: 'name[0]',
          align: 'left'
        },
        {
          text: 'Camera',
          value: 'action[0].cameraChannel[0]',
          align: 'left'
        },
        {
          text: 'Priority',
          value: 'action[0].priority[0]',
          align: 'left'
        }
      ],
      defaultSelectState: {
        label: 'None',
        val: '0'
      }
    }
  },
  computed: {
    name() {
      return this.item.name[0];
    },
    parsedChannels() {
      const channels = this.channels.map(item => (
        {
          label: item.number[0],
          val: item.number[0]
        } 
      ));
      channels.push(this.defaultSelectState);

      return channels;
    },
    parsedPins() {
      const pins = this.pinList.map(pin => (
        {
          label: pin.number[0],
          val: pin.number[0]
        }
      ));
      pins.push(this.defaultSelectState);

      return pins
    }
  },
  methods: {
    validatePriority(item, newVal, type = '') {
      let newPriority = parseInt(newVal);
      let foundIndex = this.priorityConfig.findIndex(config => 
        parseInt(config.action[0].priority[0]) == newPriority && item.name[0] != config.name[0]
      );

      logger.info('validate ', item)
      this.$emit('refreshComp')

      if (foundIndex >= 0 && type != 'channel') {
        this.$emit('updatePriority', foundIndex);
        this.$forceUpdate();  
      }
    },
    saveCameraLinkSettings() {
      logger.info('this is being sent : ', this.priorityConfig);
      this.$emit('setPriorities', this.priorityConfig);
      this.closeDialog();
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
}
</script>